<template>
       <a-button type="primary" v-if="isNew" @click="handleOpen">
        + 创建用例
      </a-button>
      <a-button type="primary" v-else-if="!formRecord.id" @click="handleOpen">
        + 采集用例
      </a-button>
      <a-button  v-else @click="handleOpen">
        编辑用例
      </a-button>
      <a-modal
        :title="formRecord.id ? '编辑用例' : '采集用例'"
        v-model:visible="openDia" 
        @cancel="resetForm" 
        @ok="handleConfirm" 
        :ok-text="btnText"
        :confirm-loading="loading"
        width="940px"
      >
        <a-form :model="formRecord" >
          <div style="display: flex; flex-direction: row; ">
            <div style="width: 600px;">
                <div v-if="!isNew" style="display: flex; flex-direction: row; justify-content: center;" >
                  <a-image-preview-group >
                    <div style="margin: 2px;">
                        <a-tag color="blue">原图</a-tag>
                        <a-image   :src="rawImage(formRecord.base_image_key)" />
                    </div>
                    <div style="margin: 2px; max-width:300px;">
                        <a-tag color="green">结果图</a-tag>
                        <template v-if="!formRecord.works" >
                          <a-image   :src="rawImage(formRecord.work_image_key)" />
                        </template>
                         <template v-else>
                         <div v-for="(item, index) in formRecord.works" :key="index"  >
                           <a-image  :src="rawImage(item.works_url)" />
                           <a-button style="margin: 10px;"  @click="() => formRecord.work_id = item.id">
                            <!-- {{ formRecord.work_id  }} -->
                            选择 {{  formRecord.work_id == item.id ? '✅' : '⬜️' }}
                          </a-button>
                         </div>
                        </template>
                    </div>
                    
                    </a-image-preview-group>
                </div>
                <div v-else  style="display: flex; flex-direction: row; justify-content: center;"  >
                  <div style="margin: 2px;">
                      <a-tag color="blue">原图 *</a-tag>
                      <Upload :maxSize="5 * 1024 * 1024" v-model:imageUrl="formRecord.base_image_key"  />
                  </div>
                  <div style="margin: 2px;">
                      <a-tag color="black">MASK</a-tag>
                      <Upload :maxSize="5 * 1024 * 1024" v-model:imageUrl="formRecord.mask_image_key"  />
                  </div>
                  <div style="margin: 2px;">
                      <a-tag color="yellow">参考图</a-tag>
                      <Upload v-if="formRecord.refer_image_key == '' || formRecord.refer_image_key.indexOf('.mp4') < 0" :maxSize="5 * 1024 * 1024" v-model:imageUrl="formRecord.refer_image_key"  />
                      <UploadVideo v-if="formRecord.refer_image_key == '' || formRecord.refer_image_key.indexOf('.mp4') > 0" v-model:videoURL="formRecord.refer_image_key"  />
                  </div>
                  <div style="margin: 2px;">
                      <a-tag color="green">结果图</a-tag>
                      <Upload :maxSize="5 * 1024 * 1024" v-model:imageUrl="formRecord.work_image_key"  />
                  </div>
                </div>
                 <div style="margin: 10px;">
                  <a-form-item label="提示词" name="prompt">
                    <a-textarea :disabled="!isNew" style="height: 120px;" v-model:value="formRecord.prompt" />
                  </a-form-item>
                </div>
                 <div style="margin: 10px;">
                  <a-form-item label="扩展参数(JSON)" name="extra_params">
                    <a-textarea :disabled="!isNew" style="height: 120px;" v-model:value="formRecord.extra_params" />
                  </a-form-item>
                </div>
            </div>
           
            <div style="width: 400px; margin: 10px;">
              <a-form-item required label="用例名称" name="case_name">
                <a-input  v-model:value="formRecord.case_name" />
              </a-form-item>
              <a-form-item required label="任务类型">
                <a-select
                  :disabled="!isNew"
                  v-model:value="formRecord.style_id"
                  :options="TaskStyleGroupOptions"
                />
              </a-form-item>
               <a-form-item label="工具类型">
                <a-select
                  :disabled="!isNew"
                  v-model:value="formRecord.tool_id"
                  :options="ToolIDOptions"
                />
              </a-form-item>
              <a-form-item label="涂抹类型">
                <a-select
                  :disabled="!isNew"
                  v-model:value="formRecord.mask_type"
                  :options="[
                    {
                      'label': '手涂',
                      'value': 'selfdefined',
                    },{
                      'label': '自动',
                      'value': 'default',
                    }
                  ]"
                />
              </a-form-item>
              <a-form-item label="任务 ID">
                <a-input :disabled="!isNew" v-model:value="formRecord.task_id" />
              </a-form-item>
              <a-form-item label="用例标签" name="labels">
                <a-select
                  v-model:value="formRecord._labels"
                  mode="multiple"
                  :options="labelOptions"
                  show-search
                  placeholder="搜索标签"
                  :filter-option="false"
                  :loading="loading"
                  @search="handleLabelSearch"
                  style="width: 100%"
                />
                <a-checkbox-group v-model:value="formRecord._labels" name="checkboxgroup" :options="labelOptions" />
                <TestcaseLabelCreate size="small"  style="margin: 4px;" @ok="() => getLabels('')" :record="{}" />
              </a-form-item>
            </div>
            
          </div>
          
         
          <!-- <a-form-item label="用例标签">
            <a-input  v-model:value="formRecord.lang_th" />
          </a-form-item> -->
        </a-form>
      </a-modal>

   
  </template>
  <script>
  
  import { defineComponent, nextTick, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  import TestcaseLabelCreate from '@/components/TestcaseLabelCreate.vue'
  import Upload from '@/components/Upload.vue'
  import UploadVideo from '@/components/UploadVideo.vue'
  import { debounce } from 'lodash'
  // import {CheckCircleOutlined,CloseCircleOutlined} from '@ant-design/icons-vue';
import { TaskStyleGroupOptions, SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'
import { rawImage} from '@/utils/image'

  const FormRecord = {
    id: 0,
    case_name: '',
    labels: '',
    task_id: '',
    base_image_key: '',
    mask_image_key: '',
    refer_image_key: '',
    work_image_key: '',
    template_id: '',
    style_id: '',
    tool_id: '',
    sub_style: '',
    _labels: [],
    extra_params: '',
    work_id: '',
  }

  export default defineComponent({
    emits: ['ok'],
    props: ['item', 'size'],
    // components:{CheckCircleOutlined,CloseCircleOutlined},
    data(){
      return {
        loading: false,
        openDia: false,
        StyleNames,TaskStyleGroupOptions,ToolIDOptions,
        labelOptions: [],
        allLabels: [],
        formRecord: {
          ...FormRecord,
        },
        btnText: "创建",
        // imageUrl: '',
      }
    },
    components: {
      Upload,UploadVideo,
      TestcaseLabelCreate,
    },
    computed: {
      isNew(){
        return  this.formRecord.id == 0 && this.formRecord.task_id == 0
      },
    },
    mounted() {
        this.resetForm()
      // this.imageUrl = this.modelValue
    },
    methods: {
      getLabels(query = ''){
        const params = {
          category: "打标",
          limit: 30,
        }
        if (query) {
          params.name = query
        }
        request.get(`/api/testcase/labels/`, params).then((rsp) => {
          if (rsp.code == 0) {
            const options = rsp.data.list.map((item) => {
              return {
                label: item.name,
                value: item.id,
              }
            })
           this.allLabels = options
           this.labelOptions = options
          } else {
            message.error(rsp.msg)
          }
        }).catch((err) => {
          message.error(err.message)
        })
      },
      handleLabelSearch: debounce(function(value) {
        console.log("search", value)
        if (!value && this.allLabels.length > 0) {
          this.labelOptions = this.allLabels
          return
        }
        
        const lowerValue = value.toLowerCase()
        
        const localMatches = this.allLabels.filter(option => 
          option.label.toLowerCase().includes(lowerValue)
        )
        
        const mergedOptions = [...localMatches]
        console.log("mergedOptions", JSON.parse(JSON.stringify(mergedOptions)))
        this.loading = true

        request.get(`/api/testcase/labels/`, {
          category: "打标",
          limit: 30,
          name: value
        }).then((rsp) => {
          if (rsp.code == 0) {
            const remoteOptions = rsp.data.list.map((item) => ({
              label: item.name,
              value: item.id,
            }))
            
            const existingIds = new Set(mergedOptions.map(opt => opt.value))
            remoteOptions.forEach(opt => {
              if (!existingIds.has(opt.value)) {
                mergedOptions.push(opt)
              }
            })
            
            nextTick(() => {
              this.labelOptions = mergedOptions
            })
            if (!value) {
              this.allLabels = remoteOptions
            }
          }
        }).catch((err) => {
          console.error('Remote search failed:', err)
          this.labelOptions = localMatches
        }).finally(() => {
          this.loading = false
        })
      }, 200),
      rawImage,
      resetForm() {
        this.formRecord = {
          ...FormRecord,
          ...this.item,
        }
        if (this.item.extra_params) {
          this.formRecord.extra_params = JSON.stringify(this.item.extra_params)
        }
        if (this.item.is_task) {
          this.formRecord.id = 0
          this.formRecord.mask_type = this.item.option == 0 ? 'selfdefined' : 'default'
          this.formRecord.prompt = this.item.trans_prompts || this.item.prompt
          this.formRecord.case_name = `${this.StyleNames[this.item.style_id]}#${this.item.id}`
          this.formRecord.task_id = `${this.item.id}`
          if (this.formRecord.works.length > 0) {
            this.formRecord.work_id = this.formRecord.works[0].id
          }
        } else {
          let labels = []
          for (let item of this.formRecord.labels) {
            labels.push(item.id)
          }
          this.formRecord._labels = labels
        }

        if (this.formRecord.id) {
          this.btnText = "编辑"
        }
      },
      async handleConfirm(){
        this.loading = true
        let labels = this.formRecord._labels.join(',')
        let req = null
        if (this.formRecord.id) {
          req = request.put(`/api/testcase/cases/${this.formRecord.id}`, {
            ...this.formRecord,
            labels: labels,
          }, '')
        } else if(this.formRecord.task_id) {
          req = request.post(`/api/testcase/cases/task`, {
            ...this.formRecord,
            labels: labels,
          }, '')
        } else {
           req = request.post(`/api/testcase/cases/new`, {
            ...this.formRecord,
            labels: labels,
          }, '')
        }
        req.then((rsp) => {
          if (rsp.code == 0) {
            message.success('采集用例成功')
          } else {
            message.error(rsp.msg)
          }
        }).catch((err) => {
          message.error(err.message)
        }).finally(() => {
          this.loading = false
          if (this.formRecord.task_id || this.formRecord.id) {
            this.$emit('ok')
            this.openDia = false
          } else {
            this.btnText = "继续创建"
            // this.openDia = false
            // this.$emit('ok')
          }
        })
      },
      handleOpen: function() {
        this.openDia = true
        console.log("this.formRecord", JSON.parse(JSON.stringify(this.formRecord)))

        this.getLabels('')
        this.resetForm()

      }
    },
  })
  </script>
  <style lang='scss' scoped>
  
  </style>